---
title: Useful Python Commands
date: 2024-04-15T12:00:00-07:00
draft: false
---

## Virtual Environments

    // 3.11 is whatever python version you want
    // 'myapp' is what you want to name your venv
    pyenv virtualenv 3.11 myapp 

    pyenv activate myapp

    pyenv deactivate myapp

## Template Blocks in Django Admin

Template blocks are placeholders in a template that you can override or amend when you override or extend a base template

    {% block content %}
        <h2>Do stuff</h2>
        {{ block.super }}  // if you don't add this, you will completely override the parent block
    {% endblock %}

- `title` Overrides the title tag of the HTML document.
- `extrahead` For adding extra HTML in the `<head>` section of the document, such as additional CSS or JavaScript.
- `coltype` Customizes the column type attribute in the `<form>` tag.
- `content` The main block where the primary content of the admin page is located.
- `field_sets` For the fields of the form displayed in the admin interface.
- `after_field_sets` Allows adding content right after the field sets block but inside the form.
- `prepopulated_fields_js` Where JavaScript for handling pre-populated fields is included.
- `submit_buttons_top` The area at the top of the page for submit buttons (usually "Save" buttons).
- `submit_buttons_bottom` Similar to submit_buttons_top, but located at the bottom of the form.
- `object-tools-items` For modifying the 'object-tools' items at the top of the change form, typically where the 'Add Another' button is located.
- `sidebar` A block used for adding a sidebar to the admin template (not always present by default).
- `breadcrumbs` For overriding the breadcrumb navigation.
- `content_title` Specific block for overriding the section of the title displayed within the content area.
- `contextual_help` A block for adding contextual help text or links.
- `below_form` For adding any content below the form but inside the body of the admin page.
- `javascript_imports` A specific block at the bottom for importing JavaScript files.